import React, { useState, useEffect } from "react";
import { Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getRefCode } from "../../pages/referral-code/referralCodeAction";

import { NoData } from "../no-data/NoData";

export const ReferralCodeTable = ({ ambassadorId }) => {
	const dispatch = useDispatch();

	const { referralCode, isPending } = useSelector(state => state.referralCode);
	const [shouldFetch, setShouldFetch] = useState(true);

	useEffect(() => {
		dispatch(getRefCode(ambassadorId));

		setShouldFetch(false);
	}, [shouldFetch, dispatch, ambassadorId]);

	if (isPending) {
		return <Spinner animation="border" variant="primary" />;
	}
	if (!referralCode) {
		return <NoData />;
	}

	return (
		<div>
			<Table striped bordered hover>
				<thead>
					<tr>
						<th>#</th>

						<th>Label</th>
						<th>Referral Code</th>
						<th>Commission</th>
						<th>StudentDiscount</th>
						<th>Created At</th>
					</tr>
				</thead>
				<tbody>
					{referralCode.map((referralCode, index) => (
						<tr key={referralCode._id}>
							<td>{index + 1}</td>

							<td>{referralCode.label}</td>
							<td>{referralCode.referralCode}</td>
							<td>${referralCode.commission}</td>
							<td>${referralCode.studentDiscount}</td>
							<td>{new Date(referralCode.createdAt).toLocaleDateString()}</td>
						</tr>
					))}
				</tbody>
			</Table>
		</div>
	);
};
